import { LoadablePaint } from '@confluence/loadable';

export const LazyThemesPage = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ThemesContainer" */ '../src/Themes/ThemesPage'))
			.ThemesPage,
});
